// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"740":"ed0ad337","772":"8d710def"}[chunkId] + ".css";
};